var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { useToast } from '~/components_to_be_packaged/toast/provider';
import DropdownButton from '~/form_components/dropdown_button';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import ExportGridViewDataToXlsx from '~/utils/exportGridViewDataToXlsx';
import { useProjectDocumentComparison } from '../providers/project_document_comparison';
import AddToProjectForm from './action_form/add_to_project';
import ExportModal from './export_modal';
const ActionMenu = (props) => {
    const { anchorDoc, comparisonDocs, tagsColumnNames, documentComparisonId } = props;
    const dispatch = useDispatch();
    const { hasPermission } = useUser();
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [isAddToProjectModalOpen, setIsAddToProjectModalOpen] = useState(false);
    const { showToast } = useToast();
    const { attachComparisonToFolder, deleteComparisonFromFolder, documentsComparisonDetail, } = useProjectDocumentComparison();
    const menuItems = useMemo(() => {
        const menu = [];
        if (hasPermission(Permissions.VIEW_PROJECT_WORKSPACE_DOCUMENT_COMPARISONS)) {
            menu.push({
                key: 'addFolder',
                name: 'Add to Folder',
            });
        }
        if (documentsComparisonDetail) {
            menu.push({
                key: 'export',
                name: 'Export',
            });
        }
        return menu;
    }, [hasPermission, documentsComparisonDetail]);
    const undoAddComparisonFormAction = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const isDeleted = yield deleteComparisonFromFolder(id);
        showToast({ id, description: isDeleted ? 'Action Undone' : 'Undo action failed' });
    });
    const addComparisonToProjectFolder = (comparisonId, folderId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield attachComparisonToFolder(comparisonId, folderId);
        if (response) {
            const projectId = response.projectId || ((_a = response.existingEntity) === null || _a === void 0 ? void 0 : _a.project.id);
            const url = `/projects-workspace/document-comparison/${projectId}`;
            const getToastMessageComponent = (text) => (React.createElement("span", null,
                text,
                React.createElement("br", null),
                React.createElement(Link, { to: url, className: 'goto-link' }, "Go to folder")));
            if (response.existingEntity) {
                showToast({
                    id: uuidv4(),
                    description: getToastMessageComponent('Comparison already exists in selected folder.'),
                });
            }
            else {
                showToast({
                    id: response.id || uuidv4(),
                    description: getToastMessageComponent('New Comparison Added.'),
                    undoCallback: undoAddComparisonFormAction,
                });
            }
        }
        else {
            showToast({
                id: uuidv4(),
                description: 'Error...',
            });
        }
    });
    const exportXlsx = (options) => {
        if (!documentsComparisonDetail)
            return;
        ExportGridViewDataToXlsx(tagsColumnNames, anchorDoc, comparisonDocs, documentsComparisonDetail, options, dispatch);
    };
    const onItemClick = (item) => {
        if (item === 'addFolder') {
            setIsAddToProjectModalOpen(true);
        }
        else if (item === 'export') {
            setIsExportModalOpen(true);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropdownButton, { title: 'Action', onMenuItemClick: onItemClick, menuItems: menuItems }),
        React.createElement(ExportModal, { isOpen: isExportModalOpen, onSubmit: exportXlsx, setIsOpen: setIsExportModalOpen }),
        React.createElement(AddToProjectForm, { onAttachComparison: addComparisonToProjectFolder, isVisible: isAddToProjectModalOpen, setIsAddToProjectVisible: setIsAddToProjectModalOpen, documentComparisonId: documentComparisonId })));
};
export default ActionMenu;
